import { TRootState } from "store";
import { IContractorsState } from "./contractors.types";

export const getContractorsSelector = (state: TRootState): IContractorsState => state.contractors;
